module.exports = __webpack_public_path__ + "fonts/WorkSans-Italic-VariableFont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/WorkSans/WorkSans-Italic-VariableFont.woff2
// module id = 3487
// module chunks = 0